import { useEffect } from "react";

export const useMountedMessage = () => {
  useEffect(() => {
    if (window.parent !== window) {
      window.parent.postMessage(
        {
          type: "mb.mounted",
        },
        "*",
      );
    }
  }, []);
};
